module.exports = __webpack_public_path__ + "static/mobile-footer-title-c079d8d79b0a5f05a27b4cf7144dd4df.svg";